import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { loadFromStorage } from "./app/features/authSlice";
import AppRoutes from "./routes";

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const hydrated = useAppSelector((state) => state.auth.hydrated);

  // Hydrate auth synchronously on app mount
  useEffect(() => {
    dispatch(loadFromStorage());
  }, [dispatch]);

  // Prevent routes/layouts from rendering before auth is ready
  if (!hydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-t-[#E50000] border-[#E9EDF3] rounded-full" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
